import { render, staticRenderFns } from "./fuel_records_tab.vue?vue&type=template&id=b47f3e48"
import script from "./fuel_records_tab.vue?vue&type=script&lang=js"
export * from "./fuel_records_tab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports